import { render, staticRenderFns } from "./pickup-point.vue?vue&type=template&id=206b62e8&scoped=true"
import script from "./pickup-point.vue?vue&type=script&lang=js"
export * from "./pickup-point.vue?vue&type=script&lang=js"
import style0 from "./pickup-point.vue?vue&type=style&index=0&id=206b62e8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b62e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('206b62e8')) {
      api.createRecord('206b62e8', component.options)
    } else {
      api.reload('206b62e8', component.options)
    }
    module.hot.accept("./pickup-point.vue?vue&type=template&id=206b62e8&scoped=true", function () {
      api.rerender('206b62e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/pickup-point.vue"
export default component.exports